// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-step-icon {
    background-color: rgba(0, 0, 0, 0.54) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/stepper/stepper.control.css"],"names":[],"mappings":"AAAA;IACI,gDAAgD;AACpD","sourcesContent":[":host ::ng-deep .mat-step-icon {\n    background-color: rgba(0, 0, 0, 0.54) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
